export default {
  GET_CAREER_LISTINGS_REQUEST: "[careerListings] GET Career Listings Request",
  UPDATE_CAREER_LISTING_REQUEST: "[careerListings] Update Career Listing Request",
  DELETE_CAREER_LISTING_REQUEST: "[careerListings] Delete Career Listing Request",
  CREATE_CAREER_LISTING_REQUEST: "[careerListings] Create Career Listing Request",
  SET_CAREER_LISTINGS: "[careerListings] SET Career Listings",
  // INSERTION_PT (for script, do not remove)
};
